package org.gstechnovos.jexonplastech.sections.about.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.style.CssStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette

val AboutHeroContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth()
            // A strong, clean branded header using the primary blue
            .backgroundColor(palette.brand.primaryBlue)
    }
}